import Challenger, { ChallengerConf, ChallengerMain } from '@aishield/challenger-react-component';
import React from 'react';
import * as uuid from 'uuid';
import { SupportedLanguage } from '../config/constants/supportedLanguage.enum';
import getAppConfig from './appConfig';
import store from './store';
import SupportedLanguageHelper from './SupportLanguageHelper';
import { ChallengerLocalization, ChallengerLocalizationMap } from '@aishield/challenger';

let challengerMain: ChallengerMain | undefined;

export const languageMap: { [K in SupportedLanguage]: string } = {
    'de-DE': 'de-DE',
    en: 'en-US',
    'en-UK': 'en-UK',
    'es-ES': 'es-ES',
    ja: 'ja-JP',
    'uk-UA': 'uk-UA',
    'zh-TW': 'zh-TW',
    'zh-CN': 'zh-CN',
    'zh-HK': 'zh-HK',
    id: 'id-ID',
    th: 'th-TH',
    ko: 'ko-KR',
    vi: 'vi-VN',
};

const MyChallengerLocalizationMap: ChallengerLocalizationMap = new Map<
    string,
    ChallengerLocalization
>([
    [
        'en-US',
        {
            captchaDescription: 'Please enter the text of the above image *',
            imNotaBot: "I'm not a robot",
            imNotaBotExplanation:
                'To prevent fraud, this is to verify that you (and not a robot) are sending requests.',
            securityCheckRequired: 'Security check (Required)',
            imNotaBotRequired: 'Cannot be blank.',
        },
    ],
    [
        'en-UK',
        {
            captchaDescription: 'Please enter the text of the above image *',
            imNotaBot: "I'm not a robot",
            imNotaBotExplanation:
                'To prevent fraud, this is to verify that you (and not a robot) are sending requests.',
            securityCheckRequired: 'Security check (Required)',
            imNotaBotRequired: 'Cannot be blank.',
        },
    ],
    [
        'de-DE',
        {
            captchaDescription:
                'Bitte gib die abgebildeten Buchstaben so ein, wie sie angezeigt werden *',
            imNotaBot: 'Ich bin kein Roboter',
            imNotaBotExplanation:
                'Um einen Betrug vorzubeugen, wird damit überprüft, ob Sie (und nicht ein Roboter) die anfrage senden',
            securityCheckRequired: 'Sicherheitsprüfung (Erforderlich)',
            imNotaBotRequired: 'Kann nicht leer sein.',
        },
    ],
    [
        'es-ES',
        {
            captchaDescription: 'Introduce los caracteres de la imagen *',
            imNotaBot: 'No soy un robot',
            imNotaBotExplanation:
                'Para evitar fraude, esta función permite verificar que tú (y no un robot) envías la petición.',
            securityCheckRequired: 'Verificación de seguridad (Obligatorio)',
            imNotaBotRequired: 'No puede dejarse en blanco.',
        },
    ],
    [
        'uk-UA',
        {
            captchaDescription: 'будь ласка, введіть текст, показаний вище *',
            imNotaBot: 'Я не робот',
            imNotaBotExplanation:
                'Ця перевірка для того, аби запобігти шахрайству і перконатись, що це ви (а не робот) надсилаєте запити.',
            securityCheckRequired: 'Перевірка безпеки (Обов\u0027язково)',
            imNotaBotRequired: 'Не може бути порожнім.',
        },
    ],
    [
        'id-ID',
        {
            captchaDescription: 'Masukkan teks yang ditampilkan di atas *',
            imNotaBot: 'Saya bukan robot',
            imNotaBotExplanation:
                'Untuk mencegah penipuan, ini untuk memverifikasi bahwa Anda (dan bukan robot) yang mengirimkan permintaan.',
            securityCheckRequired: 'Pemeriksaan keamanan (Wajib)',
            imNotaBotRequired: 'Tidak bisa kosong.',
        },
    ],
    [
        'ja-JP',
        {
            captchaDescription: '上記画像のテキストを入力してください *',
            imNotaBot: 'ロボットによる操作ではありません',
            imNotaBotExplanation:
                '不正対策のために、画面の操作がロボットではなく、お客様ご自身によるものであることを確認する項目です。',
            securityCheckRequired: 'セキュリティチェック（必須）',
            imNotaBotRequired: '必須項目です。',
        },
    ],
    [
        'th-TH',
        {
            captchaDescription: 'โปรดป้อนข้อความที่แสดงด้านบน *',
            imNotaBot: 'ฉันไม่ใช่หุ่นยนต์',
            imNotaBotExplanation:
                'เพื่อป้องกันการฉ้อโกง นี่คือการตรวจสอบว่าคุณ (ไม่ใช่หุ่นยนต์) กำลังส่งคำขอ',
            securityCheckRequired: 'ตรวจสอบความปลอดภัย (จำเป็น)',
            imNotaBotRequired: 'ไม่สามารถเว้นว่างได้',
        },
    ],
    [
        'zh-CN',
        {
            captchaDescription: '请输入上面图片显示的文字 *',
            imNotaBot: '我不是机器人',
            imNotaBotExplanation: '这是为了验证屏幕操作是由您自己而不是机器人执行的反欺诈措施。',
            securityCheckRequired: '安全检查 (必填)',
            imNotaBotRequired: '不能为空白。',
        },
    ],
    [
        'zh-TW',
        {
            captchaDescription: '請輸入上面圖片顯示的文字 *',
            imNotaBot: '我不是機器人',
            imNotaBotExplanation: '為了防止欺詐，這是為了驗證您（而不是機器人）正在發送請求。',
            securityCheckRequired: '安全檢查（必填）',
            imNotaBotRequired: '不能是空白的。',
        },
    ],
    [
        'zh-HK',
        {
            captchaDescription: '請輸入上面圖片顯示的文字 *',
            imNotaBot: '我不是機器人',
            imNotaBotExplanation: '這是為瞭驗證屏幕操作是由您自己而不是機器人執行的反欺詐措施。',
            securityCheckRequired: '安全檢查（必填）',
            imNotaBotRequired: '不能是空白的。',
        },
    ],
    [
        'ko-KR',
        {
            captchaDescription: '위 이미지의 텍스트를 입력해주세요 *',
            imNotaBot: '나는 로봇이 아니다',
            imNotaBotExplanation:
                '사기를 방지하기 위해 이는 로봇이 아닌 귀하가 요청을 보내고 있는지 확인하는 것입니다.',
            securityCheckRequired: '보안검색(필수)',
            imNotaBotRequired: '비워 둘 수 없습니다.',
        },
    ],
    [
        'vi-VN',
        {
            captchaDescription: 'Vui lòng nhập văn bản của hình ảnh trên *',
            imNotaBot: 'Tôi không phải là robot',
            imNotaBotExplanation:
                'Để ngăn chặn gian lận, điều này để xác minh rằng bạn (không phải robot) đang gửi yêu cầu.',
            securityCheckRequired: 'Yêu cầu kiểm tra bảo mật (Bắt buộc)',
            imNotaBotRequired: 'Không thể để trống.',
        },
    ],
] as Iterable<readonly [string, ChallengerLocalization]>);

export async function initChallengerMain() {
    const { CHALLENGER_ENABLED, CHALLENGER_URL } = await getAppConfig();
    if (CHALLENGER_ENABLED) {
        challengerMain = new ChallengerMain(
            new ChallengerConf(
                CHALLENGER_URL,
                'en-US',
                uuid.v4(),
                {},
                'en-US',
                60,
                1,
                1,
                1,
                5,
                'v1.0',
                MyChallengerLocalizationMap,
                undefined,
                false,
                undefined,
            ),
        );
    }
}

export function startChallenge(challengerPid: string) {
    const locale = store.getState().app.locale;
    const lang: SupportedLanguage = SupportedLanguageHelper.getSupportLanguage(locale);

    const targetLang = languageMap[lang];
    if (challengerMain !== undefined && challengerMain.defaultConf.lang !== targetLang) {
        challengerMain.defaultConf.lang = targetLang;
    }

    if (challengerMain !== undefined) {
        challengerMain.start(challengerPid);
    }
}

export function updateChallengerLanguage(lang: SupportedLanguage) {
    const targetLang = languageMap[lang];
    if (challengerMain !== undefined && challengerMain.defaultConf.lang !== targetLang) {
        challengerMain.defaultConf.lang = targetLang;
        const cpids = challengerMain.getRunningCpids();
        cpids.forEach((c) => challengerMain!.refreshChallenge(c));
        return true;
    }
    return false;
}

export function updateChallengerLanguageWithOutStop(lang: SupportedLanguage) {
    const targetLang = languageMap[lang];
    if (challengerMain !== undefined && challengerMain.defaultConf.lang !== targetLang) {
        challengerMain.defaultConf.lang = targetLang;
        const cpids = challengerMain.getRunningCpids();
        cpids.forEach((c) => challengerMain!.refreshChallenge(c));
        return true;
    }
    return false;
}

export const RenderChallenge = React.memo(
    (props: Omit<Parameters<typeof Challenger>[0], 'main'>) => {
        return challengerMain !== undefined ? (
            <Challenger main={challengerMain} {...props} />
        ) : null;
    },
);

export function destroyChallenge(challengerPid: string) {
    if (challengerMain !== undefined) {
        challengerMain.stop(challengerPid);
    }
}

export interface IChallengeData {
    trackingId: string;
    cpid: string;
    cid: string;
    cres: string;
    block_submit?: boolean;
}

export function clearChallengeInput() {
    if (challengerMain !== undefined) {
        const challengerInputElement = window.document.querySelector(
            'input[name="cres"]',
        ) as HTMLInputElement | null;
        if (challengerInputElement) {
            challengerInputElement.value = '';
        }
    }
}

export function getChallengeData(challengerPid: string): IChallengeData {
    const challengeData =
        challengerMain !== undefined ? challengerMain.getChallengerData(challengerPid) : undefined;
    return challengeData !== undefined
        ? {
              cid: challengeData.cid,
              cpid: challengeData.cpid,
              cres: challengeData.cres,
              trackingId: challengeData.tracking_id,
          }
        : {
              cid: 'challenger_disabled',
              cpid: 'challenger_disabled',
              cres: 'challenger_disabled',
              trackingId: 'challenger_disabled',
          };
}

export function isChallengerSumbitBlocked(challengerPid: string) {
    const challengeData =
        challengerMain !== undefined ? challengerMain.getChallengerData(challengerPid) : undefined;

    return challengeData !== undefined ? challengeData.block_submit : false;
}

export function refreshChallenge(challengerPid: string) {
    if (challengerMain !== undefined) {
        challengerMain.refreshChallenge(challengerPid);
    }
}
